import type { RichTextBlock } from '../../../../core/data-sources/content-components/types.js';

export const safeParse = (str: string): string | RichTextBlock[] => {
  try {
    return JSON.parse(str);
  } catch {
    return str;
  }
};
